import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Modal } from 'react-bootstrap'
import { FiCheck, FiPhone, FiMail } from 'react-icons/fi'

const contactInfo = {
    phone: '+91 8639585257',
    email: 'contact@gettoindia.com',
}

const VendorRegistrationSuccessModal = ({ show, onHide }) => {
    const navigate = useNavigate()

    const goToLogin = () => {
        if (onHide) onHide()
        navigate('/login')
    }

    return (
        <Modal
            show={show}
            onHide={goToLogin}
            centered
            backdrop="static"
            keyboard={false}
            dialogClassName="vendor-success-modal"
        >
            <Modal.Body className="vendor-success-body">
                <div className="success-icon-wrap">
                    <div className="success-icon-ring">
                        <div className="success-icon">
                            <FiCheck size={30} strokeWidth={3} />
                        </div>
                    </div>
                </div>

                <h2 className="success-title">Registration Successful!</h2>
                <p className="success-subtitle">
                    Your vendor registration has been completed successfully.
                    Our team will review your details and contact you shortly.
                </p>

                <div className="success-contact-section">
                    <div className="success-contact-heading">
                        Need help? Reach out to us
                    </div>

                    <div className="success-contact-grid">
                        <a
                            href={`tel:${contactInfo.phone.replace(/\s/g, '')}`}
                            className="success-contact-card"
                        >
                            <div className="success-contact-icon">
                                <FiPhone size={14} />
                            </div>
                            <div>
                                <div className="success-contact-label">Call us</div>
                                <div className="success-contact-value">{contactInfo.phone}</div>
                            </div>
                        </a>

                        <a
                            href={`mailto:${contactInfo.email}`}
                            className="success-contact-card"
                        >
                            <div className="success-contact-icon">
                                <FiMail size={14} />
                            </div>
                            <div>
                                <div className="success-contact-label">Email us</div>
                                <div className="success-contact-value">{contactInfo.email}</div>
                            </div>
                        </a>
                    </div>
                </div>

                <button
                    type="button"
                    className="success-primary-btn"
                    onClick={goToLogin}
                >
                    Go to Login
                </button>
            </Modal.Body>

            <style jsx global>{`
                .vendor-success-modal {
                    max-width: 460px;
                    width: calc(100% - 32px);
                    margin-left: auto;
                    margin-right: auto;
                }
                @media (max-width: 768px) {
                    .vendor-success-modal {
                        max-width: none;
                        width: calc(100% - 24px);
                    }
                }
                @media (max-width: 480px) {
                    .vendor-success-modal { width: calc(100% - 16px); }
                }
                .vendor-success-modal .modal-content {
                    border: none;
                    border-radius: 14px;
                    overflow: hidden;
                    box-shadow: 0 12px 40px rgba(16, 24, 40, 0.15);
                }
                .vendor-success-body {
                    padding: 24px 22px !important;
                    text-align: center;
                    background: #ffffff;
                }

                .vendor-success-body .success-icon-wrap {
                    display: flex;
                    justify-content: center;
                    margin-bottom: 14px;
                }
                .vendor-success-body .success-icon-ring {
                    width: 72px;
                    height: 72px;
                    border-radius: 50%;
                    background: rgba(34, 197, 94, 0.1);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    animation: successPulse 2s ease-out infinite;
                }
                .vendor-success-body .success-icon {
                    width: 52px;
                    height: 52px;
                    border-radius: 50%;
                    background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
                    color: #ffffff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 6px 14px rgba(34, 197, 94, 0.3);
                }
                @keyframes successPulse {
                    0%   { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.35); }
                    70%  { box-shadow: 0 0 0 12px rgba(34, 197, 94, 0); }
                    100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }
                }

                .vendor-success-body .success-title {
                    font-size: 17px;
                    font-weight: 700;
                    color: #0f172a;
                    margin: 0 0 6px;
                    letter-spacing: -0.2px;
                }
                .vendor-success-body .success-subtitle {
                    font-size: 12px;
                    color: #64748b;
                    line-height: 1.5;
                    margin: 0 0 16px;
                }

                .vendor-success-body .success-contact-section {
                    background: #f8fafc;
                    border: 1px solid #e6ebf1;
                    border-radius: 10px;
                    padding: 12px;
                    margin-bottom: 14px;
                    text-align: left;
                }
                .vendor-success-body .success-contact-heading {
                    font-size: 10px;
                    font-weight: 600;
                    color: #475569;
                    text-transform: uppercase;
                    letter-spacing: 0.3px;
                    margin-bottom: 8px;
                    text-align: center;
                }
                .vendor-success-body .success-contact-grid {
                    display: grid;
                    grid-template-columns: 1fr;
                    gap: 8px;
                }
                .vendor-success-body .success-contact-card {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    padding: 10px;
                    background: #ffffff;
                    border: 1px solid #e6ebf1;
                    border-radius: 8px;
                    text-decoration: none;
                    transition: all 0.2s ease;
                }
                .vendor-success-body .success-contact-card:hover {
                    border-color: #288d9d;
                    background: #f0f9fb;
                    transform: translateY(-1px);
                    box-shadow: 0 3px 10px rgba(40, 141, 157, 0.1);
                }
                .vendor-success-body .success-contact-icon {
                    width: 28px;
                    height: 28px;
                    border-radius: 7px;
                    background: rgba(40, 141, 157, 0.1);
                    color: #288d9d;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                }
                .vendor-success-body .success-contact-label {
                    font-size: 9px;
                    color: #64748b;
                    text-transform: uppercase;
                    letter-spacing: 0.3px;
                    font-weight: 600;
                }
                .vendor-success-body .success-contact-value {
                    font-size: 12px;
                    color: #0f172a;
                    font-weight: 600;
                    margin-top: 1px;
                    word-break: break-word;
                }

                .vendor-success-body .success-primary-btn {
                    width: 100%;
                    background: linear-gradient(135deg, #288d9d 0%, #1f6f7c 100%);
                    color: #ffffff;
                    border: none;
                    border-radius: 8px;
                    padding: 10px 16px;
                    font-size: 12px;
                    font-weight: 600;
                    cursor: pointer;
                    box-shadow: 0 3px 10px rgba(40, 141, 157, 0.25);
                    transition: all 0.2s ease;
                }
                .vendor-success-body .success-primary-btn:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 5px 14px rgba(40, 141, 157, 0.35);
                }

                @media (max-width: 640px) {
                    .vendor-success-body { padding: 20px 16px !important; }
                    .vendor-success-body .success-title { font-size: 15px; margin-bottom: 4px; }
                    .vendor-success-body .success-subtitle { font-size: 11px; margin-bottom: 12px; }
                    .vendor-success-body .success-icon-ring { width: 62px; height: 62px; }
                    .vendor-success-body .success-icon { width: 46px; height: 46px; }
                    .vendor-success-body .success-contact-section { padding: 10px; margin-bottom: 12px; }
                    .vendor-success-body .success-contact-heading { font-size: 9px; margin-bottom: 6px; }
                    .vendor-success-body .success-contact-card { padding: 8px; gap: 8px; }
                    .vendor-success-body .success-contact-icon { width: 26px; height: 26px; border-radius: 6px; }
                    .vendor-success-body .success-contact-label { font-size: 8.5px; }
                    .vendor-success-body .success-contact-value { font-size: 11px; }
                    .vendor-success-body .success-primary-btn { padding: 9px 14px; font-size: 11.5px; }
                }
            `}</style>
        </Modal>
    )
}

export default VendorRegistrationSuccessModal
